export default [
  {
    header: "الممتلكات",
    icon: "BookOpenIcon",
    children: [
      {
        title: "الآليات",
        route: "vehicles",
        icon: "TruckIcon",
        slug:'ngo_vehicles'
      },
      {
        title: "العقارات",
        route: "real-estates",
        icon: "GridIcon",
        slug:'ngo_real-estates'
      },
    ],
  },
];
